import { FC } from 'react'
import { useNavigate } from 'react-router'

import { theme } from 'antd'

import routes from '../../routes'

import LogoImage from './logo.svg?react'

const Logo: FC<{ size?: number | string }> = ({ size = 64 }) => {
  const navigate = useNavigate()
  const { token } = theme.useToken()
  return (
    <LogoImage
      color={token.colorWhite}
      style={{ cursor: 'pointer' }}
      onClick={() => navigate(routes.home)}
      width={size}
      height={size}
    />
  )
}

export { Logo }
